import { StateStore } from '@bingads-webui/state-store';

export const sharedComponentFunctionStateStore = new StateStore({});
